import { CRM_TYPES } from 'crms/constants';

const GOOGLE_TAG_MANAGER_IDS = {
  [CRM_TYPES.mt]: 'GTM-KQBP2V',
  [CRM_TYPES.tat]: 'GTM-PN2PD84',
};

export const GOOGLE_TAG_MANAGER_ID = GOOGLE_TAG_MANAGER_IDS[__CRM__];
